import { LABELS_GA_NAMES } from 'common/constants';
import { Product } from 'common/components/product-card/types';

export const isOnlineOnly = (source: string) => source?.toUpperCase() === 'PIM';

export const getProductBelongFromSource = (productSource: string | undefined) => {
  let productBelong: 'LM' | 'LMMarket' = 'LM';
  if (productSource?.toLowerCase() === 'pim') {
    productBelong = 'LMMarket';
  }
  return productBelong;
};

export const getGaTag = (product: Product) => {
  if (product.productPriceCategory === 'STD' && !product.price.previous_price) {
    if (isOnlineOnly(product.source)) {
      return LABELS_GA_NAMES.PIM;
    }
    return null;
  }
  if (
    product.productPriceCategory &&
    product.productPriceCategory.toLowerCase() !== 'pim' &&
    isOnlineOnly(product.source)
  ) {
    return `${LABELS_GA_NAMES[product.productPriceCategory]},onlineOnly`;
  }
  return LABELS_GA_NAMES[product.productPriceCategory];
};
